import CuepointDots from "components/CuepointDots";
import { connect } from "react-redux";
import makeGetCuepointBuckets from "selectors/cuepoint/makeGetCuepointBuckets";
import { WithSliderDimensions } from "context/Slider";
import { compose, fromRenderProps } from "recompose";

const makeMapStateToProps = () => {
  const getCuepointBuckets = makeGetCuepointBuckets();
  return (state, ownProps) => {
    const bucketCount = getCuepointBuckets(state, ownProps).length;
    return {
      numberOfCuepoints: bucketCount,
      showCuepoints: state.playerOptions.hideCuepoints !== true,
    };
  };
};

export default compose(
  fromRenderProps(WithSliderDimensions, ({ sliderDimensions }) => ({
    sliderWidth: sliderDimensions.width,
  })),
  connect(makeMapStateToProps),
)(CuepointDots);
